import { ColumnData } from "assets/types/ColumnData";
import { Chip } from "@mui/material";

type ChipColor = "default" | "success" | "error" | "warning" | "info";

// Map a PendingRefundStatus to a chip colour.
const statusColor = (status?: string): ChipColor => {
	const s = (status || "").toUpperCase();
	if (s === "PROCESSED") return "success";
	if (s === "FAILED") return "error";
	if (s === "PENDING") return "warning";
	return "info";
};

const columns: ColumnData[] = [
	{
		headerName: "Product",
		field: "productName",
		renderCell: ({ row }) => <>{row.productName}</>,
	},
	{
		headerName: "Amount",
		field: "amount",
		renderCell: ({ row }) => <>{row.amount}</>,
	},
	{
		headerName: "Type",
		field: "refundType",
		renderCell: ({ row }) => <>{row.refundType}</>,
	},
	{
		headerName: "Destination",
		field: "destination",
		renderCell: ({ row }) => <>{row.destination}</>,
	},
	{
		headerName: "Status",
		field: "status",
		renderCell: ({ row }) => (
			<Chip
				label={row.status || "-"}
				color={statusColor(row.status)}
				size="small"
			/>
		),
	},
	{
		headerName: "Date",
		field: "date",
		renderCell: ({ row }) => <>{row.date}</>,
	},
];

const dataTableData = {
	columns,
};

export default dataTableData;
